import type { LscLeagueSetupProgressStepId } from './types';

export interface OnboardingStepDefinition {
  id: LscLeagueSetupProgressStepId;
  label: string;
  shortLabel: string;
  description: string;
}

export const ONBOARDING_STEP_ORDER: OnboardingStepDefinition[] = [
  {
    id: 'subscription',
    label: 'Subscription',
    shortLabel: 'Subscribe',
    description: 'Confirm your league subscription is active and linked.',
  },
  {
    id: 'league_basics',
    label: 'League profile',
    shortLabel: 'League',
    description: 'Set league name, game, platform, and visibility basics.',
  },
  {
    id: 'schedule_source',
    label: 'Schedule',
    shortLabel: 'Schedule',
    description: 'Connect NeonSportz or import your season schedule.',
  },
  {
    id: 'members_teams',
    label: 'Members and teams',
    shortLabel: 'Members',
    description: 'Add members, assign teams, and prepare broadcaster roster.',
  },
  {
    id: 'twitch_live',
    label: 'Twitch live detection',
    shortLabel: 'Twitch',
    description: 'Connect Twitch logins and confirm live detection readiness.',
  },
  {
    id: 'automation_settings',
    label: 'Automation settings',
    shortLabel: 'Settings',
    description: 'Review live and archive automation policies before go-live.',
  },
  {
    id: 'automation_activation',
    label: 'Activate automations',
    shortLabel: 'Activate',
    description: 'Turn on production automations when readiness checks pass.',
  },
];

const STEP_INDEX = new Map(
  ONBOARDING_STEP_ORDER.map((step, index) => [step.id, index] as const)
);

export function isOnboardingStepId(value: string | null | undefined): value is LscLeagueSetupProgressStepId {
  return Boolean(value && STEP_INDEX.has(value as LscLeagueSetupProgressStepId));
}

export function onboardingStepDefinition(
  stepId: LscLeagueSetupProgressStepId
): OnboardingStepDefinition {
  return ONBOARDING_STEP_ORDER[STEP_INDEX.get(stepId) ?? 0];
}

export function nextOnboardingStepId(
  stepId: LscLeagueSetupProgressStepId
): LscLeagueSetupProgressStepId | null {
  const index = STEP_INDEX.get(stepId);
  if (index === undefined || index >= ONBOARDING_STEP_ORDER.length - 1) {
    return null;
  }
  return ONBOARDING_STEP_ORDER[index + 1].id;
}

export function previousOnboardingStepId(
  stepId: LscLeagueSetupProgressStepId
): LscLeagueSetupProgressStepId | null {
  const index = STEP_INDEX.get(stepId);
  if (index === undefined || index <= 0) {
    return null;
  }
  return ONBOARDING_STEP_ORDER[index - 1].id;
}
